import round1entries from "./round1entries";

const dev = {
  env: "dev",
  algorithm_label: "dev-algorithm",
  s3: {
    REGION: "us-east-2",
    BUCKET: "cihackathon-algorithm-uploads",
  },
  apiGateway: {
    REGION: "us-east-2",
    //URL: "https://ymxsln5oke.execute-api.us-east-2.amazonaws.com/prod",
    URL: "https://iyfp4i0lad.execute-api.us-east-2.amazonaws.com/dev",
  },
  leaderboardapiGateway: {
    REGION: "us-east-2",
    //URL: "https://ymxsln5oke.execute-api.us-east-2.amazonaws.com/prod",
    URL: "https://iyfp4i0lad.execute-api.us-east-2.amazonaws.com/dev",
  },
  cognito: {
    REGION: "us-east-2",
    USER_POOL_ID: "us-east-2_CqPRRaFmB",
    APP_CLIENT_ID: "5kmoegbeh8porgj9jo21cnvkmu",
    IDENTITY_POOL_ID: "us-east-2:1b9706cc-28ce-478e-ac59-66cb1bf9ee49",
  },
};

const prod = {
  env: "prod",
  algorithm_label: "algorithm",
  s3: {
    REGION: "us-east-2",
    BUCKET: "cihackathon-algorithm-uploads",
  },
  apiGateway: {
    REGION: "us-east-2",
    URL: "https://ymxsln5oke.execute-api.us-east-2.amazonaws.com/prod",
  },
  leaderboardapiGateway: {
    REGION: "us-east-2",
    URL: "https://ymxsln5oke.execute-api.us-east-2.amazonaws.com/prod",
  },
  cognito: {
    REGION: "us-east-2",
    USER_POOL_ID: "us-east-2_CqPRRaFmB",
    APP_CLIENT_ID: "5kmoegbeh8porgj9jo21cnvkmu",
    IDENTITY_POOL_ID: "us-east-2:1b9706cc-28ce-478e-ac59-66cb1bf9ee49",
  },
};

// Default to dev if not set
const config = process.env.REACT_APP_STAGE === "prod" ? prod : dev;

config.ROUND1_ENTRIES_PER_SET = 120;
config.ROUND2_ENTRIES_PER_SET = 30;
config.entries = round1entries; // or round3entries

// Set vocoder bucket location for playback
config.VOCODER_BUCKET_URL =
  "https://cihackathon-vocoder-outputs.s3.us-east-2.amazonaws.com/";

export default {
  // Add common config values here
  MAX_ATTACHMENT_SIZE: 50000000,
  ...config,
};
